var page = 1;

window.slideTimer = function () {
  $('.nav-arrow-next').click();
};

$(function () {
  getContents();

  var int = setInterval('slideTimer()', 6000);

  $('.slide-list').on('mouseover', function () {
    window.clearInterval(int);
  });

  $('.slide-list').on('mouseout', function () {
    int = setInterval('slideTimer()', 6000);
  });
});

function toSlides(data) {
  var newlist = '';
  for (var i = 0; i < data.length; i++) {
    var info = data[i];
    if (i == 0) newlist += '<div class="slide-item current" data-index="' + i + '">';
    else newlist += '<div class="slide-item" data-index="' + i + '">';
    newlist += '<a href="' + info.url + '" target="_blank">';
    if (info.poster_url != '') newlist += '<img src="' + info.poster_url + '?w=390&h=270&s=3" />';
    else if (info.thumbnail_urls.length > 0) newlist += '<img src="' + info.thumbnail_urls[0] + '?w=390&h=270&s=3" />';
    else newlist += '<img />';
    newlist += '</a>';
    newlist += '<div class="slide-content">';
    newlist += '<a href="' + info.url + '" target="_blank">';
    newlist += '<div class="slide-title">' + info.title + '</div>';
    newlist += '</a>';
    newlist += '<div class="slide-summary">' + info.summary + '</div>';
    newlist += '</div>';
    newlist += '</div>';
  }

  $('.slide .slide-items').append(newlist);

  while (data.length < $('#nav-dots span').length) {
    $('#nav-dots span:last').remove();
  }
}

function getContents() {
  $.ajax({
    type: 'get',
    async: false,
    url: ROOT + '/home/contents?id=zthj&page=' + page + '&size=999',
    data: null,
    contentType: 'application/json',
    dataType: 'json',
    success: function (data) {
      if (data == '') {
        return;
      }
      if (data.message !== undefined) {
        alert('操作失败:' + data.message);
        return;
      }
      if (data.data === undefined) {
        alert('操作失败');
        return;
      }
      toSlides((data.data || []).slice(0, 5));
      var newlist = toListHtml(data);

      $('.list .newsItems').append(newlist);
      page++;

      if (data.data.length < 10) {
        $('.list .more').addClass('no-more');
      }

      if ($('.newsItem').length == 0) $('.list').html('<div style="text-align: center;">暂无内容</div>');
    },
    error: function (data) {
      console.log(data);
      if (data.message !== undefined) alert('获取列表失败:' + data.message);
      else alert('获取列表失败');
    },
  });
}

function toListHtml(data) {
  var newlist = '';
  for (var i = 0; i < data.data.length; i++) {
    var info = data.data[i];
    var tmpUrl = '';
    if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '') {
      tmpUrl = ROOT + '/static/images/no-thumb.png';
    } else {
      tmpUrl = info.thumbnail_urls[0] + '?w=346&h=170&s=3';
    }

    newlist += '<div class="newsItem">';
    newlist += '<a href="' + info.url + '" class="newsItem-img">';
    newlist += '<img src="' + tmpUrl + '" />';
    newlist += '</a>';
    newlist += '<a href="' + info.url + '" class="newsItem-title">' + info.title + '</a>';
    newlist += '<div class="newsItem-time">' + info.publish_time + '</div>';
    newlist += '</div>';
    if (i % 3 == 2 && i != data.data.length - 1) newlist += '<div class="special-line"></div>';
  }
  if (data.data.length % 3 != 0) {
    for (var i = data.data.length % 3; i < 3; i++) {
      newlist += '<div class="newsItem"></div>';
    }
  }

  return newlist;
}
